import * as types from './types'

export const changeLanguage = (payload) => {
    return {
      type: types.CHANGE,
      payload,
    };
  };